import { ApiResponse } from '../types/api';
import { AgentRequest, AgentResponse } from '../types/api/agent';
import { agentApi } from './base';

const getVerifyAgent = agentApi.injectEndpoints({
  endpoints: (builder) => ({
    getVerifyAgent: builder.query<ApiResponse<AgentResponse>, AgentRequest>({
      query: (params) => ({
        url: '/GetAgentData',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetVerifyAgentQuery } = getVerifyAgent;
